export var TABLE_FOOT_CLASS_PREFIX = 'TableFoot';
export var tableFootRootTestId = 'TableFootRoot';